// Mirrors the backend's multer cap on avatar uploads (`avatarMulter` in
// user.route.js). Client-side checks against this are UX fast-fails only —
// the backend remains the enforcer.
export const MAX_AVATAR_BYTES = 5 * 1024 * 1024;
